// Sentry must be first import
import "@/utils/sentry";
import "@/utils/posthog";
import "@/utils/errorReload";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@mantine/core/styles.layer.css";
import "@mantine/dates/styles.layer.css";
import "@mantine/charts/styles.layer.css";
import "@mantine/notifications/styles.layer.css";
import "@mantine/carousel/styles.layer.css";
import "@mantine/dropzone/styles.layer.css";
import "mantine-datatable/styles.layer.css";
import "@fontsource/work-sans"; // alternative: Montserrat, Roboto, DM Sans, Rubik
import "./styles/index.css";

import App from "@/App";
import { reactRootErrorOptions } from "@/utils/sentry";

const root = document.getElementById("root");
if (root) {
  createRoot(root, reactRootErrorOptions).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
